import { Typography } from '@mui/material';
import { memo } from 'react';

import ChevronLeft from '@vp/assets/icons/ChevronLeft.svg?react';
import { VpHeader, VpHeaderColumn } from '@vp/common/ui/component/VpHeader';
import { VpIconButton } from '@vp/common/ui/component/VpIconButton';

export const AccessManagerHeader = memo(() => {
  return (
    <VpHeader
      sx={{
        position: 'sticky',
        width: 1,
        pb: 1,
        px: { tablet: 4 },
        pt: { tablet: 2 },
        backgroundColor: 'background.300',
      }}
    >
      <VpHeaderColumn align="left">
        <VpIconButton glowing Icon={ChevronLeft} sx={theme => ({ [theme.breakpoints.up('desktop')]: { p: 1 } })} to=".." />
      </VpHeaderColumn>
      <VpHeaderColumn>
        <Typography variant="h6" color="text.primary" textAlign="center">
          Ограничение доступа
        </Typography>
      </VpHeaderColumn>
      <VpHeaderColumn align="right" />
    </VpHeader>
  );
});

AccessManagerHeader.displayName = 'AccessManagerHeader';
